import React, { useEffect, useMemo, useRef, useState } from "react"
import { Container } from "reactstrap"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import TableContainer from "components/Common/TableContainer"
import eye from "../../../assets/images/icons/eye.svg"
import IcdProcess from "../../../assets/images/icd-process.png"
import deleteIcon from "../../../assets/images/icons/delete-red.svg"
import { Link } from "react-router-dom"
import DeleteConfirmationModal from "modals/deleteConfirmation"
import moment from "moment"
import {
  formatAmount,
  formatTenure,
  getIcdRequestStatus,
  getIcdsStatus,
  getTableSortingHeaderIcon,
} from "helpers/common"
import {
  useDeleteIcdRequestMutation,
  useLazyMyIcdRequestsQuery,
} from "store/api/investorapi/icds.api"
import { usePermission } from "hooks/usePermission"
const defaultFilters = {
  search: "",
  page: 1,
  created_by: "INVESTOR",
  pageSize: 20,
  timestamp: "",
}

const MyICDRequests = () => {
  const [getResults, { isFetching }] = useLazyMyIcdRequestsQuery()
  const [onDelete, { isLoading: isDeleting }] = useDeleteIcdRequestMutation()
  const [filters, setFilters] = useState(defaultFilters)
  const [data, setData] = useState([])
  const [count, setCount] = useState(0)
  const [isToast, setIsToast] = useState(false)
  const deleteRef = useRef(null)
  const { hasPermission } = usePermission()

  //meta title
  document.title = "ICD Investments - Prachay"

  const getList = async () => {
    try {
      const { data } = await getResults(filters).unwrap()
      setData(data?.rows)
      setCount(data?.count)
    } catch (e) {}
  }

  useEffect(() => {
    getList()
  }, [filters])

  const onDeleteSuccess = () => {
    setIsToast(false)
    deleteRef.current = null
    setFilters((prev) => ({ ...prev, page: 1, timestamp: moment().unix() }))
  }

  const columns = useMemo(() => [
    {
      header: ({ column }) => getTableSortingHeaderIcon(column, " Request ID"),
      accessorKey: "unique_code",
      enableColumnFilter: false,
      enableSorting: true,
      cell: ({ row }) => (
        <div className="code-number">{row?.original.unique_code}</div>
      ),
    },
    {
      header: ({ column }) =>
        getTableSortingHeaderIcon(column, " Fund Availability Date"),
      accessorKey: "fund_requirement_date",
      enableColumnFilter: false,
      enableSorting: true,
      cell: ({ row }) => (
        <>
          {moment(row?.original?.icdsRequest.fund_requirement_date).format(
            "D MMM YYYY"
          )}
        </>
      ),
    },
    {
      header: ({ column }) => getTableSortingHeaderIcon(column, " Amount (₹)"),
      accessorKey: "amount",
      enableColumnFilter: false,
      enableSorting: true,
      cell: ({ row }) => (
        <div>₹ {formatAmount(row?.original?.icdsRequest.amount)}</div>
      ),
    },
    {
      header: ({ column }) => getTableSortingHeaderIcon(column, " Interest"),
      accessorKey: "interest_rate",
      enableColumnFilter: false,
      enableSorting: true,
      cell: ({ row }) => (
        <div className="">{row?.original?.icdsRequest.interest_rate} %</div>
      ),
    },
    {
      header: ({ column }) =>
        getTableSortingHeaderIcon(column, "Date of Repayment"),
      accessorKey: "repayment_date",
      enableColumnFilter: false,
      enableSorting: true,
      cell: ({ row }) => (
        <div className="">
          {row?.original?.icdsRequest.repayment_date
            ? moment(row?.original?.icdsRequest.repayment_date).format(
                "D MMM YYYY"
              )
            : ""}
        </div>
      ),
    },
    {
      header: () => <div className="flex items-center gap-2">Status</div>,
      accessorKey: "status",
      enableColumnFilter: false,
      enableSorting: false,
      cell: ({ row }) => (
        <div className="code-status">
          {getIcdRequestStatus(row?.original?.icdsRequest?.status)}
        </div>
      ),
    },
    {
      id: "action",
      header: "Actions",
      cell: ({ row }) => (
        <div className="d-flex justify-content-center align-items-center gap-3">
          {hasPermission("VIEW_INVESTMENT") && (
            <div className="action-view">
              <Link to={`/icd-investments/my-icds/view/${row?.original.id}`}>
                <img src={eye} alt="" />
              </Link>
            </div>
          )}
          {row?.original?.created_by === "INVESTOR" && (
            <div
              className="action-delete"
              onClick={() => {
                deleteRef.current = row?.original
                setIsToast(true)
              }}
            >
              <img src={deleteIcon} alt="" />
            </div>
          )}
        </div>
      ),
    },
  ])

  const HeaderComponent = () => (
    <>
      <img src={IcdProcess} className="img-fluid mb-2" alt="" />
    </>
  )

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title={"List of Investments"} breadcrumbItem={"ICDs"} />
          <TableContainer
            isLoading={isFetching}
            count={count}
            filters={filters}
            setFilters={setFilters}
            HeaderComponent={HeaderComponent}
            columns={columns}
            data={data}
            isGlobalFilter={true}
            isCustomPageSize={true}
            // isGlobalFilter={true}
            isPagination={true}
            pagination="pagination"
            paginationWrapper="dataTables_paginate paging_simple_numbers"
            tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
          />
        </Container>

        {isToast && deleteRef && (
          <DeleteConfirmationModal
            open={isToast}
            id={deleteRef.current.id}
            setOpen={setIsToast}
            isLoading={isDeleting}
            onClose={() => {
              setIsToast(false)
              deleteRef.current = null
            }}
            title={"Delete ICD"}
            description="Are you sure you want to delete this icd?"
            onDelete={onDelete}
            onSuccess={onDeleteSuccess}
          />
        )}
      </div>
    </React.Fragment>
  )
}

export default MyICDRequests
